import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import Protected from "@/components/Protected";

// Shell pages
const HotelDashboard      = lazy(() => import("@/pages/HotelDashboard"));
const HotelGuestAssistance = lazy(() => import("@/pages/HotelGuestAssistance"));
const HotelAppointments   = lazy(() => import("@/pages/HotelAppointments"));
const HotelRooms          = lazy(() => import("@/pages/HotelRooms"));
const HotelQrAnalytics    = lazy(() => import("@/pages/HotelQrAnalytics"));
const HotelServiceUtilization = lazy(() => import("@/pages/HotelServiceUtilization"));
const HotelStaff          = lazy(() => import("@/pages/HotelStaff"));
const HotelSettings       = lazy(() => import("@/pages/HotelSettings"));
const HotelFolios         = lazy(() => import("@/pages/HotelFolios"));
const HotelStatement      = lazy(() => import("@/pages/hotel/HotelStatement"));
const HotelFolioApprovals = lazy(() => import("@/pages/HotelFolioApprovals"));
const HotelChargeExemptions = lazy(() => import("@/pages/HotelChargeExemptions"));
const HotelServiceRecovery = lazy(() => import("@/pages/HotelServiceRecovery"));
const HotelShiftHandover  = lazy(() => import("@/pages/HotelShiftHandover"));
const HotelArrivals       = lazy(() => import("@/pages/HotelArrivals"));
const HotelLedger         = lazy(() => import("@/pages/HotelLedger"));
const QrAdmin             = lazy(() => import("@/pages/QrAdmin"));
const QrPrint             = lazy(() => import("@/pages/QrPrint"));
const HotelBranding       = lazy(() => import("@/pages/HotelBranding"));
const AdminObservability  = lazy(() => import("@/pages/AdminObservability"));
const CorporateAdmin      = lazy(() => import("@/pages/CorporateAdmin"));

const H = ["hotel_staff", "hotel_manager"];
const M = ["hotel_manager"];          // /hotel-admin/* is manager-only server-side
const HP = [...H, "platform_admin"];  // /hotel/ledger + hotel-admin views

export default (
  <>
    {/* Canonical hotel portal */}
    <Route path="/hotel"                     element={<Navigate to="/hotel/dashboard" replace />} />
    <Route path="/hotel/dashboard"           element={<Protected roles={H}><HotelDashboard /></Protected>} />
    <Route path="/hotel/guest-assistance"    element={<Protected roles={H}><HotelGuestAssistance /></Protected>} />
    <Route path="/hotel/appointments"        element={<Protected roles={H}><HotelAppointments /></Protected>} />
    <Route path="/hotel/rooms"               element={<Protected roles={H}><HotelRooms /></Protected>} />
    <Route path="/hotel/qr"                  element={<Protected roles={H}><QrAdmin /></Protected>} />
    <Route path="/hotel/qr/print"            element={<Protected roles={HP}><QrPrint /></Protected>} />
    <Route path="/hotel/qr-analytics"        element={<Protected roles={H}><HotelQrAnalytics /></Protected>} />
    <Route path="/hotel/service-utilization" element={<Protected roles={H}><HotelServiceUtilization /></Protected>} />
    <Route path="/hotel/billing"             element={<Protected roles={HP}><HotelLedger /></Protected>} />
    <Route path="/hotel/statement"           element={<Protected roles={[...M, "platform_admin"]}><HotelStatement /></Protected>} />
    <Route path="/hotel/folios"              element={<Protected roles={H}><HotelFolios /></Protected>} />
    <Route path="/hotel/folio-approvals"     element={<Protected roles={H}><HotelFolioApprovals /></Protected>} />
    <Route path="/hotel/charge-exemptions"   element={<Protected roles={M}><HotelChargeExemptions /></Protected>} />
    <Route path="/hotel/service-recovery"    element={<Protected roles={H}><HotelServiceRecovery /></Protected>} />
    <Route path="/hotel/handover"            element={<Protected roles={H}><HotelShiftHandover /></Protected>} />
    <Route path="/hotel/arrivals"            element={<Protected roles={H}><HotelArrivals /></Protected>} />
    <Route path="/hotel/staff"               element={<Protected roles={M}><HotelStaff /></Protected>} />
    <Route path="/hotel/settings"            element={<Protected roles={H}><HotelSettings /></Protected>} />
    <Route path="/hotel/branding"            element={<Protected roles={H}><HotelBranding /></Protected>} />
    <Route path="/hotel/observability"       element={<Protected roles={H}><AdminObservability /></Protected>} />
    <Route path="/hotel/corporate"           element={<Protected roles={H}><CorporateAdmin /></Protected>} />

    {/* Legacy portal paths — permanently redirect to canonical /hotel/* URLs. */}
    <Route path="/staff"                element={<Navigate to="/hotel/dashboard" replace />} />
    <Route path="/admin/qr"             element={<Navigate to="/hotel/qr" replace />} />
    <Route path="/admin/qr/print"       element={<Navigate to="/hotel/qr/print" replace />} />
    <Route path="/admin/branding"       element={<Navigate to="/hotel/branding" replace />} />
    <Route path="/admin/observability"  element={<Navigate to="/hotel/observability" replace />} />
    <Route path="/admin/corporate"      element={<Navigate to="/hotel/corporate" replace />} />
    <Route path="/admin/ledger"         element={<Navigate to="/hotel/billing" replace />} />
    <Route path="/admin/folio-charges"  element={<Navigate to="/hotel/folio-approvals" replace />} />
  </>
);
